import React from 'react';

import MailNotificationClientToggleableCard from './MailNotificationClientToggleableCard';

const NotificationsCardClientToggleable = ({
  adminMailing,
  clientMailing,
  mailing,
}) => (
  <MailNotificationClientToggleableCard
    adminMailing={adminMailing}
    clientMailing={clientMailing}
    mailing={mailing}
  />
);

export default NotificationsCardClientToggleable;
